"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoucherStatusToJSON = exports.VoucherStatusFromJSONTyped = exports.VoucherStatusFromJSON = exports.VoucherStatus = void 0;
/**
 * Voucher status, used for filtering, indicates the current lifecycle status of the Voucher
 * @export
 */
exports.VoucherStatus = {
    Used: 'USED',
    Unused: 'UNUSED',
    Expired: 'EXPIRED',
    Available: 'AVAILABLE'
};
function VoucherStatusFromJSON(json) {
    return VoucherStatusFromJSONTyped(json, false);
}
exports.VoucherStatusFromJSON = VoucherStatusFromJSON;
function VoucherStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.VoucherStatusFromJSONTyped = VoucherStatusFromJSONTyped;
function VoucherStatusToJSON(value) {
    return value;
}
exports.VoucherStatusToJSON = VoucherStatusToJSON;
